import { render, staticRenderFns } from "./SubSidenav.vue?vue&type=template&id=f09f475e&scoped=true&"
import script from "./SubSidenav.vue?vue&type=script&lang=js&"
export * from "./SubSidenav.vue?vue&type=script&lang=js&"
import style0 from "./SubSidenav.vue?vue&type=style&index=0&id=f09f475e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09f475e",
  null
  
)

export default component.exports